import { Component } from '@angular/core'
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController
} from 'ionic-angular'
import { Observable } from 'rxjs'

import { ApiProvider } from '../../providers/api/api'
import { CallsProvider } from '../../providers/api/calls.provider'
import { SettingsProvider } from '../../providers/settings/settings'
import { AddCallPage } from '../add-call/add-call'
import { AddMeetingPage } from '../add-meeting/add-meeting'
import { Call, CallStatus, DealStatus } from './../../models/models'


@IonicPage()
@Component({
  selector: 'page-call-detail',
  templateUrl: 'call-detail.html',
})
export class CallDetailPage {
  call: Call = null
  parent = null
  CallStatus = CallStatus
  DealStatus = DealStatus

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public settings: SettingsProvider,
    private readonly apiProvider: ApiProvider,
    private readonly callsProvider: CallsProvider,
    private readonly alertCtrl: AlertController,
    private readonly toastCtrl: ToastController,
    private readonly loading: LoadingController,
    private readonly modalCtrl: ModalController) {
    if (typeof navParams.get('call') != 'undefined') {
      this.call = navParams.get('call')
    }
    this.parent = (navParams && navParams.get('parent')) || null
  }

  callContact() {
    window.open('tel:' + this.call.deal.contact.phone, '_system', 'location=yes')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactDetailPage');
  }

  setCancel() {
    let title = "Chiamata non fatta"
    let status = CallStatus.CANCEL

    this.setStatus(title, status);
  }

  setDone() {
    let title = "Chiamata fatta"
    let status = CallStatus.DONE

    this.setStatus(title, status);
  }

  private setStatus(title: string, status: CallStatus) {
    let action = this.callsProvider.setStatus(this.call.id, status)

    this.confirmAction(title, action);
  }



  private confirmAction(title: string, action: Observable<any>) {
    this.alertCtrl.create({
      title: title,
      message: "Confermi la scelta?",
      buttons: [
        {
          text: "Indietro",
          handler: () => { }
        },
        {
          text: "Conferma",
          handler: () => {
            // Aggiorno Stato appuntamento
            let l = this.showLoader();
            action.subscribe(call => {
              this.call = call;
              this.parentRefresh()
              l.dismiss();
              this.notifyOk();
            }, _e => {
              l.dismiss();
              this.notifyError();
            });
          }
        }
      ]
    }).present();
  }

  parentRefresh() {
    this.parent && this.parent.refresh && this.parent.refresh()
  }

  leaveContact() {
    let action = this.apiProvider.setDealAsLost(this.call.deal.id)
    this.confirmAction('Abbandona contatto', action)
  }

  setHot() {
    this.apiProvider.markDealAsHot(this.call.deal.id, true).subscribe(deal => {
      this.call.deal = deal
      this.notifyOk()
    }, _e => {
      this.notifyError()
    })
  }


  newMeeting() {
    let contact = this.call.deal.contact
    if (contact != null) {
      console.log('Creo un meeting con', contact.name)
      let meetingModal = this.modalCtrl.create(AddMeetingPage, { contact: contact, deal: this.call.deal }, { showBackdrop: true })
      meetingModal.onDidDismiss(_value => {
      })
      meetingModal.present()
    }
  }

  newCall() {
    let contact = this.call.deal.contact
    if (contact != null) {
      console.log('Creo un call con', contact.name)
      let callModal = this.modalCtrl.create(AddCallPage, { contact: contact, deal: this.call.deal }, { showBackdrop: true })
      callModal.onDidDismiss(_value => {
      })
      callModal.present()
    }
  }


  notifyOk() {
    this.toastCtrl.create({
      message: 'Operazione conclusa con successo',
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }

  notifyError(e: string = "") {
    this.toastCtrl.create({
      message: 'Si è verificato un errore ' + e,
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }

  showLoader() {
    let l = this.loading.create({
      content: "Attendere.."
    })
    l.present()
    return l
  }

}



// WEBPACK FOOTER //
// ./src/pages/call-detail/call-detail.ts